import * as React from 'react';
import { actions as toastrActions } from 'react-redux-toastr';
import { Action } from 'redux';
import * as uuid from 'uuid/v4';

// Triggers
// undo
export const UNDO = 'UNDO';

interface UndoBaseAction extends Action {
    readonly id: string;
}

export interface UndoAction extends UndoBaseAction {
    readonly type: 'UNDO';
}

export const undo = (id: string): UndoAction => ({ type: UNDO, id });

export const UNDO_SHOW = 'UNDO_SHOW';

export interface UndoShowAction extends UndoBaseAction {
    readonly type: 'UNDO_SHOW';
    readonly message: string;
    readonly button: string;
}

export const undoShow = (id: string, message: string, button: string): UndoShowAction => ({ type: UNDO_SHOW, id, message, button });

export const UNDO_HIDE = 'UNDO_HIDE';

export interface UndoHideAction extends UndoBaseAction {
    readonly type: typeof UNDO_HIDE;
}

export const undoHide = (id: string): UndoHideAction => ({ type: UNDO_HIDE, id });

export const DEVICE_CHANGED = 'DEVICE_CHANGED';

export interface DeviceChangedAction extends Action {
    readonly type: typeof DEVICE_CHANGED;
    readonly mobile: boolean;
    readonly desktop: boolean;
}

export const deviceChanged = (mobile: boolean, desktop: boolean): DeviceChangedAction => ({ type: DEVICE_CHANGED, mobile, desktop });

export const VIEWPORT_CHANGED = 'VIEWPORT_CHANGED';

export interface ViewportChangedAction extends Action {
    readonly type: typeof VIEWPORT_CHANGED;
    readonly width: number;
    readonly height: number;
}

export const viewportChanged = (width: number, height: number): ViewportChangedAction => ({ type: VIEWPORT_CHANGED, width, height });

export const ORIENTATION_CHANGED = 'ORIENTATION_CHANGED';

type Orientation = 'portrait' | 'landscape';
export interface OrientationChangedAction extends Action {
    readonly type: typeof ORIENTATION_CHANGED;
    readonly orientation: Orientation;
}

export const orientationChanged = (orientation: Orientation): OrientationChangedAction => ({ type: ORIENTATION_CHANGED, orientation });

export const SOFT_KEYBOARD_TOGGLE = 'SOFT_KEYBOARD_TOGGLE';

export interface SoftKeyboardToggleAction extends Action {
    readonly type: typeof SOFT_KEYBOARD_TOGGLE;
    readonly opened: boolean;
    readonly height?: number;
}

export const softKeyboardToggle = (opened: boolean, height?: number): SoftKeyboardToggleAction => ({ type: SOFT_KEYBOARD_TOGGLE, opened, height });

// export actions from toastr
export interface ToastOptions {
    timeOut?: number;
    removeOnHover?: number | boolean;
    component?: React.ReactType;
}

export const toastAdd: {
    (type: string, options?: ToastOptions): Action;
    (type: string, id: string, options?: ToastOptions): Action;
} = (type: string, id: string | ToastOptions, options?: ToastOptions) => {

    if (typeof id === 'object') {
        options = id;
        id = uuid();
    }

    return toastrActions.add({
        type,
        id,
        position: 'top-center',
        options: {
            timeOut: 5000,
            removeOnHover: 2500,
            transitionIn: 'bounceInDown',
            ...options,
        },
    });
};

export const ANALYTICS_STORE_EVENT = 'ANALYTICS_STORE_EVENT';

export interface AnalyticsStoreEventAction extends Action {
    readonly type: typeof ANALYTICS_STORE_EVENT;
    readonly name: string;
    readonly props: any;
    readonly redirect: string;
}

export const analyticsStoreEvent = (name: string, props: any, redirect: string = null): AnalyticsStoreEventAction => ({
    type: ANALYTICS_STORE_EVENT,
    name, props, redirect,
});

// Action for unauthenticated users
export const FORUM_POST_ADD_UNAUTHENTICATED = 'FORUM_POST_ADD_UNAUTHENTICATED';

export interface AddPostUnauthenticatedAction extends Action {
    readonly type: typeof FORUM_POST_ADD_UNAUTHENTICATED;
}

export const addPostUnauthenticated = (): AddPostUnauthenticatedAction => ({
    type: FORUM_POST_ADD_UNAUTHENTICATED,
});
